import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Configuration, ToursService } from '../../api-client';
import { Observable } from 'rxjs';
import { Tour } from '../../models/tour';

@Injectable({
  providedIn: 'root',
})
export class TourService extends ToursService {
  constructor(httpClient: HttpClient, config: Configuration) {
    super(httpClient, config.basePath!, config);
  }

  /**
   * Get tours from API
   */
  getAll(): Observable<Tour[]> {
    return super.getToursEndpoint();
  }
}
